<template>
  <div class="norecord" :style="{ backgroundColor: mycolor}" v-cloak>
      <img :src="img.url"  style="width:4.4rem; height:3.5rem;margin:0 auto; margin-top:1.4rem;">
      <div id="mymsg">{{msg}}</div>
  </div>
</template>

<script>
export default {
  name: 'Norecord',

  props: ['msg','mycolor'],
  data() {
    return {
        'img':{url:require('../assets/images/norecord.png'),}
    };
  },
  computed: {

  },
  created() {

  },
  mounted() {

  },
  watch: {

  },
  methods: {

  },
  components: {

  },
};
</script>

<style scoped lang="css">
    .norecord{width: 100%;height: auto;padding: 0 0.3rem;padding-top: 0.3rem; text-align: center}
    .norecord img{width: 100%;height: auto;}
    .norecord #mymsg{width: 100%;font-size: 0.4rem;color: #AAC1E8;text-align: center;padding-bottom: 0.4rem; }
</style>



// WEBPACK FOOTER //
// src/components/Norecord.vue